<template>
  <div class="customerBalanceList">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @companyChange="companyChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="false"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :height="'200'"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :min-width="120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
      <credit-Statistics-List
        v-if="query.partnerCodes"
        ref="creditStatisticsList"
        :params="query.partnerCodes"
      />
    </div>
  </div>
</template>
<script>
  import API from '@/api/purchaseSalesCenter/customerBalance/customerBalance';
  import tableMixins from '@/common/mixins/table.js';
  import DataBaseAPI from '@/api/dataBase';
  import CreditStatisticsList from './components/creditStatisticsList'; // 信用额度统计
  export default {
    name: 'customerBalanceList',
    components: {
      CreditStatisticsList,
    },
    mixins: [tableMixins],
    computed: {
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            //公司代码
            prop: 'businessCompanyCode',
            name: this.$t('formulaBalance.search.businessCompanyName'),
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            filterable: true,
          },
          {
            //客户名称
            prop: 'customer',
            type: 'searchTableSpec',
            name: this.$t('formulaBalance.search.partnerName'),
            searchType: 'supplier',
            extraData: {
              partnerTypes: 'HZHB03,HZHB01',
              companyCode: this.query.businessCompanyCode,
            },
            isMultiple: true,
          },
          {
            //余额类型
            prop: 'balanceType',
            name: this.$t('customerBalanceAdjust.search.balanceType'),
            type: 'dict',
            dictType: 'balance_type',
          },
        ];
      },
    },
    data() {
      return {
        exportAction: API.EXPORT_PDEXPENSEDETAIL,
        query: {
          businessCompanyCode: null, //公司代码
          customer: null, // 客户
          partnerCodes: null, // 客户代码
          partnerName: null, // 客户名称
          balanceType: null, //余额类型
        },
        columnListDefault: [
          { type: 'checkbox', width: '50', fixed: 'left' }, // 复选框
          {
            // 公司代码
            field: 'businessCompanyCode',
            title: this.$t('formulaBalance.table.businessCompanyCode'),
          },
          {
            // 公司名称
            field: 'businessCompanyName',
            title: this.$t('formulaBalance.table.businessCompanyName'),
          },
          {
            // 客户代码
            field: 'partnerCode',
            title: this.$t('formulaBalance.table.partnerCode'),
          },
          {
            // 客户名称
            field: 'partnerName',
            title: this.$t('formulaBalance.table.partnerName'),
          },
          {
            // 余额类型
            field: 'balanceType',
            title: this.$t('customerBalanceAdjust.table.balanceType'),
            dictType: 'balance_type',
          },
          {
            // 余额
            field: 'formulaAmount',
            title: this.$t('formulaBalance.table.formulaAmount'),
          },
        ],
        companyList: [],
        departmentList: [],
      };
    },
    mounted() {
      this.getData();
      this.getCompany();
      this.getButtonList();
    },
    methods: {
      async getData() {
        // 获取列表数据
        this.load = true;
        if (this.query.customer) {
          this.query.partnerCodes = this.query.customer.map((item) => item.partnerCode);
        } else {
          this.query.partnerCodes = null;
          this.load = false;
          this.$refs.siruiTable.reloadTable();
          return this.$message({ showClose: true, message: '请选择客户', type: 'error' });
        }
        const params = { ...this.query };
        let res = await this.$axios.post(API.QUERY_CUSTOMERBALANCE_LIST, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data;
            //this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userInfo.userCode,
            userCode: this.userInfo.userInfo.userCode,
            personName: this.userInfo.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      companyChange(val) {
        console.log(val);
        // 切换公司
      },
      chooseClick(type) {
        if (type == 'export') {
          // 导出
          this.commonExport();
        }
      },
    },
  };
</script>
